import type { WarehouseLedgerTransactionItem } from '@/services/warehouseTypes'

export function coerceLedgerNumeric(value: unknown): number | null {
  if (value == null || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

export function coerceLedgerMoneyFields(
  item: WarehouseLedgerTransactionItem
): WarehouseLedgerTransactionItem {
  return {
    ...item,
    signed_cases: coerceLedgerNumeric(item.signed_cases) ?? 0,
    balance: coerceLedgerNumeric(item.balance) ?? 0,
    unit_cost: coerceLedgerNumeric(item.unit_cost),
    shipping_alloc: coerceLedgerNumeric(item.shipping_alloc) ?? 0,
    pick_fee_alloc: coerceLedgerNumeric(item.pick_fee_alloc) ?? 0,
    receiving_alloc: coerceLedgerNumeric(item.receiving_alloc) ?? 0,
  }
}

export function formatUnitCostDisplay(value: number | string | null | undefined): string {
  const n = value == null ? null : Number(value)
  if (n == null || !Number.isFinite(n)) return ''
  const amount = n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  return `$${amount}`
}

export type LedgerMoneyCommitResult =
  | { action: 'cancel' }
  | { action: 'commit'; value: number | null }

export type ResolveLedgerMoneyCommitOptions = {
  emptyClears?: boolean
}

export function resolveLedgerMoneyCommit(
  draft: string,
  currentValue: number | null,
  options?: ResolveLedgerMoneyCommitOptions
): LedgerMoneyCommitResult {
  const raw = draft.trim().replace(/[$,]/g, '')
  if (raw === '') {
    if (options?.emptyClears || currentValue == null) {
      return { action: 'commit', value: null }
    }
    return { action: 'cancel' }
  }
  const next = Number(raw)
  if (!Number.isFinite(next)) return { action: 'cancel' }
  const current = currentValue == null ? null : Number(currentValue)
  if (next === current) return { action: 'cancel' }
  return { action: 'commit', value: next }
}
